import { capitalize } from "lodash";

const slugToTitle = (slug?: string) => {
  if (!slug) {
    return "";
  }

  return capitalize(slug.replaceAll("-", " "));
};

export default slugToTitle;
